import { FileKind, FileModel } from '@/typings/api/files';

/** Human-readable size. Null size (legacy rows) shows as nothing, not "0 B". */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '';

  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;

  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }

  // Bytes and kilobytes are noise below the decimal point; megabytes are not.
  const decimals = unit >= 2 && value < 10 ? 1 : 0;

  return `${value.toFixed(decimals)} ${units[unit]}`;
}

/**
 * Whether the file can be shown as itself. Only images can — a font or a PDF
 * gets an icon, because a thumbnail of either would be a picture of nothing.
 */
export function isPreviewable(file: FileModel): boolean {
  return file.kind === 'image';
}

/** The `accept` attribute for an upload restricted to certain kinds. */
export function acceptFor(kinds?: FileKind[]): string | undefined {
  if (!kinds || kinds.length === 0) return undefined;

  const accepts: Record<FileKind, string> = {
    image: 'image/*',
    font: '.woff,.woff2,.ttf,.otf',
    document: 'application/pdf',
  };

  return kinds.map((kind) => accepts[kind]).join(',');
}
